<template>
  <!-- Global FAB bottom right -->
  <v-speed-dial
    v-model="fabGlobal"
    direction="bottom"
    transition="slide-y-reverse-transition"
    class="global-fab"
  >
    <v-btn slot="activator" v-model="fabGlobal" color="success" fab small class="mr-0">
      <v-icon>add</v-icon>
      <v-icon>close</v-icon>
    </v-btn>
    <v-btn :ripple="false" class="pr-0 mr-0 mb-0 ml-0 pa-0" flat href="/">
    <v-chip color="success" text-color="white" class="pr-2">
        <v-icon dark size="22" class="mr-2">shopping_basket</v-icon>
      New Order
    </v-chip>
    </v-btn>
    <v-btn :ripple="false" class="pr-0 mr-0 mb-0 ml-0 pa-0" flat href="/">
    <v-chip xs color="success" text-color="white" class="pr-2">
        <v-icon size="22" class="mr-2" dark>person</v-icon>
      New Customer
    </v-chip>
    </v-btn>
    <v-btn :ripple="false" class="pr-0 mr-0 mb-0 ml-0 pa-0" flat href="/">
    <v-chip xs color="success" text-color="white" class="pr-2">
        <v-icon size="22" class="mr-2" dark>eco</v-icon>
      New Something else
    </v-chip>
    </v-btn>
  </v-speed-dial>
</template>

<script>
export default {
  name: "GlobalFAB",
  data: () => ({
    fabGlobal: false
  }),
  methods: {}
}
</script>

<style>

.global-fab {
  position:absolute;
  top:-7px;
  right:0;
}

.global-fab.v-speed-dial--direction-bottom .v-speed-dial__list {
  align-items:flex-start;
}

.global-fab .v-chip .v-chip__content {
  cursor:pointer;
}

.global-fab .v-speed-dial__list .v-btn:before, .global-fab .v-speed-dial__list .v-btn:after{
  display:none !important;
}

</style>
